import OPCODE from './OPCODE';
import { TYPES } from '../stores/auth';
import config from '../config';
import router from '../router';
import store from '../stores';

export default (opcode) => {
  switch (opcode) {
    case OPCODE.ACCOUNT.EXPIRED:
      config.alert.mixin({
        type: 'error',
        title:
          '만료된 사용자는 연장 후 사용이 가능합니다. 전산 처리까지 최대 10분 걸릴 수 있습니다.',
      });
      return false;
    case OPCODE.COMPANY.EXISTS:
      config.alert.mixin({
        type: 'error',
        title: '해당 사이트는 존재하지 않습니다',
      });
      router.push('/signin');
      return false;
    case OPCODE.LOW_BALANCE:
      config.alert.mixin({
        type: 'error',
        title: '잔액이 부족합니다.',
      });
      return false;
    case OPCODE.COMPANY.EXPIRED:
      config.alert.mixin({
        type: 'error',
        title: '해당 사이트는 만료되었습니다.' + '\n관리자에게 문의하세요.',
      });
      router.push('/signin');
      return false;
    case OPCODE.COMPANY.DISABLED:
      config.alert.mixin({
        type: 'error',
        title:
          '관리자에 의하여 정지된 사이트입니다.' + '\n관리자에게 문의하세요.',
      });
      router.push('/signin');
      return false;
    case OPCODE.ACCOUNT.EXISTS:
      store.commit(TYPES.CHANGE_AUTH_STATUS, false);
      router.push('/signin');
      config.alert.mixin({
        type: 'error',
        title: '아이디 또는 비밀번호가' + '\n잘못되었거나 존재하지 않습니다.',
      });
      return false;
    case OPCODE.ACCOUNT.DISABLED:
      store.commit(TYPES.CHANGE_AUTH_STATUS, false);
      config.alert.mixin({
        type: 'error',
        title:
          '관리자에 의하여 정지된 계정입니다.' + '\n관리자에게 문의하세요.',
      });
      return false;
    case OPCODE.ADMIN.EXISTS:
      config.alert.mixin({
        type: 'error',
        title: '아이디 또는 비밀번호가' + '\n잘못되었거나 존재하지 않습니다.',
      });
      return false;
    case OPCODE.ACCOUNT.REQUIRED_LOGIN:
      store.commit(TYPES.CHANGE_AUTH_STATUS, false);
      router.push('/signin');
      config.alert.mixin({
        type: 'error',
        title: '로그인이 필요한 서비스입니다.',
      });
      return false;
    case OPCODE.ADMIN.REQUIRED_LOGIN:
      router.push('/admin/signin');
      config.alert.mixin({
        type: 'error',
        title: '로그인이 필요한 서비스입니다.',
      });
      return false;
    case OPCODE.UNCLE.REQUIRED_LOGIN:
      router.push('/uncle/signin');
      config.alert.mixin({
        type: 'error',
        title: '로그인이 필요한 서비스입니다.',
      });
      return false;
    case OPCODE.UNCLE.EXISTS:
      config.alert.mixin({
        type: 'error',
        title: '아이디 또는 비밀번호가' + '\n잘못되었거나 존재하지 않습니다.',
      });
      return false;
    case OPCODE.MASTER.EXISTS:
      config.alert.mixin({
        type: 'error',
        title: '아이디 또는 비밀번호가' + '\n잘못되었거나 존재하지 않습니다.',
      });
      return false;
    case OPCODE.MASTER.REQUIRED_LOGIN:
      router.push('/master/signin');
      config.alert.mixin({
        type: 'error',
        title: '로그인이 필요한 서비스입니다.',
      });
      return false;
    case OPCODE.ERROR:
      config.alert.mixin({
        type: 'error',
        title: '알 수 없는 오류가 발생하였습니다.',
      });
  }
  return true;
};
